<template>
    <ul class="Breadcrumbs flex row-center">
        <li
            v-for="({ key, to, icon, label }, index) in (breadcrumbs || list)"
            :key="key"
            class="flex row-center"
        >
            <WIcon
                v-if="index"
                icon="chevron-right"
                :size="16"
                color="accent-blue"
            />
            <Component
                :is=" to ? 'RouterLink' : 'div'"
                :to="to"
                class="Link"
            >
                <WIcon
                    v-if="icon"
                    :icon="icon"
                    :size="20"
                    color="accent-blue"
                />
                <WText
                    tag="span"
                    class="mb-0"
                    :size="22"
                >
                    {{ label }}
                </WText>
            </Component>
        </li>
    </ul>
</template>
<script>
import VueTypes from 'vue-types'
import { capitalize } from '@/utils/format'

export default {
    name: 'Breadcrumbs',
    props: {
        breadcrumbs: VueTypes.any,
    },
    data () {
        return {
            list: [],
        }
    },
    watch: {
        $route: {
            handler (route) {
                const { params, meta } = route || {}
                const { method } = meta || {}
                const { entity, id } = params || {}
                const breadcrumbs = []

                if (entity) {
                    breadcrumbs.push({
                        key: 'entity',
                        label: capitalize(entity),
                        to: { name: 'AdminEntity', params: { entity } },
                    })
                }

                if (id && method) {
                    breadcrumbs.push({
                        key: method,
                        label: capitalize(method),
                        to: { name: 'AdminDetailItem', params: { entity, id } },
                    })
                }

                this.list = breadcrumbs
            },
            immediate: true,
        },
    },
}
</script>
<style scoped lang="scss">
.Breadcrumbs {
    margin: 0;
    padding: 0;

    li {
        & > .WIcon {
            margin-right: 8px;
        }

        & + li {
            margin-left: 8px;
        }
    }
}
</style>
